<template>
  <div class="home">
    <div class="container my-3 py-3 px-4">
      <div class="row">
        <div class="col-12">
          <h2 class="text-start">Site Types</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3 ms-auto">
          <button
            class="btn btn-primary w-100"
            @click="goToCreateNewSiteType">
            <i class="bi bi-plus-circle-fill"></i> Create New Site Type
          </button>
        </div>
      </div>
      <div class="row">
          <div class="col-12 col-lg-4 mb-4">
            <ca-smtt-input
              type="text"
              label="Search"
              placeholder="Search sites by name"
              iconClear
              @clearInput="(e) => this.sitesTypesSearchOptions = e"
              @input="handleSearchSitesTypes"
            />
          </div>
        </div>

        <div class="row"
          v-if="filteredSiteTypes.length === 0"
        >
          <div class="col-12 text-uppercase">
            site type not found
          </div>
        </div>

        <div
          v-else
          class="row"
          :class="{
            'px-4': mobileDisplay
          }"
        >
          <table
            class="table table-responsive table-hover text-start rounded-3"
          >
            <thead id="table-headers" class="table-primary">
              <tr>
                <th scope="col">Type</th>
                <th scope="col">Description</th>
                <th scope="col" class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody id="table-body">
              <tr
                class="text-start cursor-pointer"
                v-for="(siteType, index) in filteredSiteTypes" :key="index"
                :title="`Go to ${siteType.type} details`"
              >
                <td header="Type" scope="row" class="word-wrap"> {{ siteType.type ? siteType.type : '<TBD>'}} </td>
                <td header="Description"> {{ siteType.description ? siteType.description : 'No site type description' }} </td>
                <td header="Actions" class="d-flex justify-content-start justify-content-xl-evenly">
                  <button
                    class="btn btn-label"
                    title="Edit"
                    @click="goToEditSiteType($event, siteType.id)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button
                    class="btn btn-label"
                    title="Delete"
                    @click="handleDeleteSiteType($event, siteType)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</template>

<script>
import caSmttInput from '@/components/ca-smtt-input.vue'
import { getAllSiteTypes } from '@/services/sitesTypes/sites_types.api.js'
import { mapState } from 'vuex'

export default {
  components: { caSmttInput },
  name: 'Home',
  data() {
    return {
      users: [],
      sites: [],
      sitesTypes: [],
      userSearchOptions: [],
      sitesSearchOptions: [],
      sitesTypesSearchOptions: [],
      dropdownText: null,
      linkRegExp: /^(ftp|http|https):\/\/[^ "]+$/,
    }
  },
  async mounted() {
    await this.showSiteTypesTable()
  },
  methods: {
    async showSiteTypesTable(){
      this.dropdownText = 'Sites Types'
      this.$store.commit('setMainScreenDropdown', 'Sites Types')
      this.users = []
      this.sites = []
      try {
        const {data} = await getAllSiteTypes()
        // console.log('Sites Types =>', data.typeSites)
        this.sitesTypes = data.typeSites
      } catch (error) {
        console.log(error)
      }
    },
    goToCreateNewSiteType() {
      this.$router.push(`/site/type/create`)
    },
    goToEditSiteType(event, siteTypeId) {
      event.stopPropagation();
      this.$router.push(`/site/type/edit/${siteTypeId}`)
    },
    handleDeleteSiteType(event, siteType) {
      event.stopPropagation()
      console.log(siteType.type)
    },
    handleSearchSitesTypes(event) {
      this.sitesTypesSearchOptions = event.target.value
    },
  },
  computed: {
    ...mapState(['mobileDisplay', 'user']),
    filteredSiteTypes() {
      return this.sitesTypesSearchOptions.length > 0 ?
        this.sitesTypes.filter(site => {
          if (site.type.toLowerCase().includes(this.sitesTypesSearchOptions.toLowerCase())) {
            return site
          }
        }
        ) :
        this.sitesTypes
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>